import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { LeaveApplicationResponse } from '../interfaces/leave.interface';

interface CreateLeaveDto {
    leaveType: string;
    leaveReason: string;
    startDate: string;
    endDate: string;
    institutionId: string;
}

export const LeaveService = {
    getLeaveApplications: async (page: number = 0, size: number = 10): Promise<LeaveApplicationResponse> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.LEAVE_APPLICATION.LOGGED_IN_USER_APPLICATION_BY_INSTITUTION(institutionId), {
            params: { page, size },
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    createLeaveApplication: async (leaveData: CreateLeaveDto, files?: File[]): Promise<void> => {
        leaveData.institutionId = AuthService.getSelectedInstitution()!!;
        const formData = new FormData();
        formData.append('leaveApplication', new Blob([JSON.stringify(leaveData)], { type: 'application/json' }));
        if (files && files.length > 0) {
            files.forEach(file => formData.append('documents', file));
        }
        await axios.post(ENDPOINTS.LEAVE_APPLICATION.BASE, formData, {
            headers: {
                ...AuthService.getAuthHeader(),
                'Content-Type': 'multipart/form-data',
            }
        });
    },

    cancelLeaveApplication: async (id: string): Promise<void> => {
        await axios.patch(ENDPOINTS.LEAVE_APPLICATION.CANCEL(id), {}, {
            headers: AuthService.getAuthHeader()
        });
    },

    getAllApplicationsByInstitution: async (page: number = 0, size: number = 10, userId?: string): Promise<LeaveApplicationResponse> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const params: Record<string, string | number> = { page, size };
        if (userId) params.userId = userId;
        const response = await axios.get(ENDPOINTS.LEAVE_APPLICATION.ALL_APPLICATION_BY_INSTITUTION(institutionId), {
            params,
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    approveLeaveApplication: async (id: string): Promise<void> => {
        await axios.patch(ENDPOINTS.LEAVE_APPLICATION.APPROVE(id), {}, {
            headers: AuthService.getAuthHeader()
        });
    },

    rejectLeaveApplication: async (id: string): Promise<void> => {
        await axios.patch(ENDPOINTS.LEAVE_APPLICATION.REJECT(id), {}, {
            headers: AuthService.getAuthHeader()
        });
    },

    downloadDocument: async (documentId: string, fileName: string): Promise<void> => {
        const response = await axios.get(ENDPOINTS.LEAVE_DOCUMENT.DOWNLOAD(documentId), {
            headers: AuthService.getAuthHeader(),
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }
};
